import React, { forwardRef } from 'react'
import { useAppSelector } from '../../../../../../../../../../app/hooks'
import { InitState } from '../../../../../../../../../../redux/reducers/root/initialState'
import { AttachmentType } from '../../../../../../../../../../@types/types'
import { WebViewMultimediaPreview } from './WebViewMultimediaPreview'
import { InitialUploadClickableArea } from './InitialUploadClickableArea'

interface MobileMultimediaButtonProps {
  dropzoneId: string
}

export const WebViewMultimediaButton = forwardRef<HTMLDivElement, MobileMultimediaButtonProps>(
  ({ dropzoneId }, ref) => {
    const attachments = useAppSelector((state: InitState) => state.multimediaFeature.attachments || [])

    // Check if there are any picture attachments with URLs
    const hasPictures = attachments.some(
      (attachment) => attachment.attachmentType === AttachmentType.PICTURE && attachment.attachment?.url
    )

    return hasPictures ? (
      <WebViewMultimediaPreview dropzoneId={dropzoneId} pluploadRef={ref} />
    ) : (
      <InitialUploadClickableArea dropzoneId={dropzoneId} pluploadRef={ref} />
    )
  }
)
